import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export const ClockColorIcon = ({ className, style, ...props }: IconProps) => (
  <svg
    className={classNames(["h-full w-full", className])}
    style={style}
    {...props}
    viewBox='0 0 41 41'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M40.2344 21.7312C39.6889 22.8599 38.728 23.2246 37.7596 22.663C37.213 22.3402 37.0064 21.8269 36.9644 21.2265C36.9354 20.7865 36.9053 20.3442 36.9892 19.9052C37.1312 19.1628 37.6445 18.6366 38.3396 18.5215C39.0346 18.4064 39.7276 18.7561 40.0902 19.4243C40.1397 19.5146 40.1849 19.6082 40.2322 19.7008L40.2344 21.7312Z'
      fill='url(#paint0_linear_1565_22828)'
    />
    <path
      d='M20.1889 4.16574C15.9279 4.23891 12.1781 5.63877 9.00933 8.51704C6.13321 11.1295 4.31479 14.3629 3.76819 18.2009C2.94829 23.9553 4.59024 28.9533 8.80381 33.0205C11.086 35.2231 13.8222 36.6068 16.9318 37.2373C17.6108 37.374 18.223 37.5999 18.5071 38.295C18.6325 38.5696 18.6771 38.8741 18.6358 39.1731C18.5944 39.4721 18.4688 39.7531 18.2736 39.9833C17.8281 40.546 17.2127 40.6708 16.552 40.5428C12.913 39.8617 9.53707 38.1763 6.80571 35.6771C3.84243 33.0022 1.88306 29.7248 0.872703 25.877C0.298655 23.6722 0.109732 21.3847 0.314265 19.1155C0.637061 15.3496 1.94224 11.9624 4.17599 8.9356C6.18323 6.18962 8.87308 4.01571 11.9791 2.62923C13.9951 1.71652 16.1488 1.14493 18.3521 0.937779C21.9547 0.577917 25.5869 1.21399 28.8527 2.77664C29.6208 3.13289 30.3604 3.54765 31.0649 4.01726C31.3103 4.18296 31.4319 4.14315 31.5857 3.9032C31.9085 3.39964 32.2571 2.91329 32.6025 2.4248C32.7403 2.23112 32.9049 2.0482 33.176 2.09124C33.4472 2.13428 33.5462 2.36562 33.6064 2.59373C34.1003 4.34436 34.5985 6.09392 35.0708 7.84993C35.2581 8.54394 34.8557 9.04643 34.1326 9.11099C32.5035 9.2584 30.8756 9.41442 29.2465 9.5629C29.0651 9.57797 28.883 9.58336 28.701 9.57904C28.1167 9.57259 27.9231 9.23903 28.2394 8.73762C28.5557 8.23621 28.9022 7.74125 29.2594 7.26244C29.4467 7.01066 29.4079 6.88369 29.1454 6.72445C26.9695 5.35548 24.5052 4.51085 21.947 4.2572C21.3595 4.1948 20.7774 4.2034 20.1889 4.16574Z'
      fill='url(#paint1_linear_1565_22828)'
    />
    <path
      d='M17.8991 15.5448C17.8991 13.5169 17.8991 11.4883 17.8991 9.45902C17.8991 8.82526 18.0648 8.27543 18.6943 7.972C18.893 7.8726 19.1138 7.82555 19.3359 7.83531C19.5579 7.84507 19.7737 7.9113 19.963 8.02776C20.1523 8.14421 20.3087 8.30703 20.4175 8.50081C20.5263 8.69459 20.5839 8.91292 20.5848 9.13515C20.5998 10.4263 20.5848 11.71 20.5848 12.9969C20.5848 15.364 20.5848 17.7312 20.5783 20.0984C20.5783 20.3997 20.6687 20.5632 20.9409 20.7031C24.2141 22.3816 27.4836 24.0674 30.7496 25.7602C31.1004 25.9421 31.4297 26.1379 31.605 26.521C31.8493 27.0525 31.7793 27.5464 31.4038 27.9736C31.2436 28.1733 31.0261 28.3194 30.7806 28.3923C30.535 28.4652 30.2731 28.4614 30.0298 28.3814C29.6898 28.2834 29.3928 28.0908 29.0818 27.9294C25.5239 26.0924 21.9645 24.2589 18.4037 22.429C18.0282 22.2375 17.8797 22.019 17.884 21.5919C17.9109 19.5765 17.8991 17.5612 17.8991 15.5448Z'
      fill='url(#paint2_linear_1565_22828)'
    />
    <path
      d='M34.2924 34.4017C33.5855 34.4168 33.1088 34.1101 32.8011 33.5614C32.4858 32.9954 32.4934 32.4068 32.8711 31.8656C33.1395 31.4819 33.4313 31.115 33.7448 30.767C34.0179 30.4744 34.3891 30.2924 34.7877 30.2557C35.1863 30.219 35.5844 30.3301 35.9064 30.568C36.2328 30.8008 36.4615 31.1462 36.5483 31.5376C36.6351 31.929 36.574 32.3387 36.3766 32.6877C36.0899 33.1687 35.7403 33.6095 35.3372 33.9982C35.2027 34.1371 35.0396 34.2451 34.8592 34.3148C34.6788 34.3845 34.4854 34.4141 34.2924 34.4017Z'
      fill='url(#paint3_linear_1565_22828)'
    />
    <path
      d='M29.5607 38.4148C28.7838 38.3868 28.2695 38.1038 27.9693 37.5023C27.6691 36.9008 27.7315 36.1606 28.2135 35.6947C28.7196 35.1852 29.3423 34.807 30.0277 34.5929C30.656 34.4035 31.3522 34.694 31.7396 35.2384C32.1269 35.7829 32.1979 36.5361 31.7815 37.0676C31.2229 37.7641 30.4364 38.2411 29.5607 38.4148Z'
      fill='url(#paint4_linear_1565_22828)'
    />
    <path
      d='M35.7653 27.2615C35.9224 26.6697 36.0655 25.9316 36.5099 25.3247C36.9725 24.692 37.801 24.5274 38.5058 24.8599C38.8368 25.0187 39.1046 25.2845 39.2661 25.6142C39.4275 25.9439 39.4732 26.3184 39.3957 26.6772C39.2818 27.2116 39.0962 27.7281 38.8437 28.2127C38.6678 28.5358 38.3863 28.7886 38.0462 28.9289C37.7062 29.0691 37.3282 29.0883 36.9758 28.9831C36.2613 28.7808 35.762 28.1277 35.7653 27.2615Z'
      fill='url(#paint5_linear_1565_22828)'
    />
    <path
      d='M23.7217 40.5718C22.8362 40.5718 22.225 40.1221 22.0109 39.4141C21.7968 38.7061 22.0464 37.9195 22.6737 37.5773C23.3676 37.1849 24.1659 37.0166 24.9591 37.0953C25.694 37.1749 26.1987 37.756 26.3117 38.5479C26.3464 38.8858 26.2732 39.226 26.1025 39.5196C25.9318 39.8133 25.6724 40.0453 25.3616 40.1823C24.801 40.4169 24.1941 40.5051 23.7217 40.5718Z'
      fill='url(#paint6_linear_1565_22828)'
    />
    <path
      d='M37.2775 12.4176C37.8413 12.4047 38.2954 12.5909 38.5687 13.0105C38.9991 13.6561 39.2939 14.363 39.3132 15.1485C39.316 15.4824 39.2122 15.8085 39.017 16.0794C38.8218 16.3503 38.5452 16.5519 38.2276 16.6549C37.5637 16.8776 36.7933 16.6872 36.4113 16.1244C35.9825 15.5169 35.7334 14.801 35.6925 14.0585C35.6796 13.8444 35.7114 13.63 35.7857 13.4288C35.8601 13.2276 35.9754 13.044 36.1244 12.8898C36.2734 12.7355 36.4529 12.6139 36.6514 12.5326C36.8498 12.4513 37.0631 12.4122 37.2775 12.4176Z'
      fill='url(#paint7_linear_1565_22828)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint6_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
      <linearGradient
        id='paint7_linear_1565_22828'
        x1='0.234375'
        y1='0.839844'
        x2='41.6991'
        y2='2.43159'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FE901F' />
        <stop offset='1' stopColor='#A94AC7' />
      </linearGradient>
    </defs>
  </svg>
);
